import { addStyles } from 'ethcss'
import grid from 'blocks.simple/grid/grid.jcss'
import { colors, IStyles, mediaCSS } from '../../../theme'

const styles: IStyles = {
    title: {
        marginTop: 12,
    },
    button: {
        width: 200,
        display: 'flex',
        justifyContent: 'center',
    },
    groupsBlock: {
        maxWidth: 600,
        border: `1px solid ${colors.grey}`,
        borderRadius: '5px 5px 0 0',
        overflow: 'hidden',
        marginTop: 14,
    },
    groupsHeader: {
        background: colors.greyLight,
        padding: 10,
        fontWeight: 600,
    },
    groupItem: {
        position: 'relative',
        display: 'flex',
        alignItems: 'center',
        padding: 10,
        borderTop: `1px solid ${colors.grey}`,
    },
    groupItemNumber: {
        minWidth: 24,
        fontWeight: 'bold',
    },
    groupItemDelete: {
        position: 'absolute',
        top: '50%',
        right: 10,
        transform: 'translateY(-50%)',
    },
    modal: {
        position: 'fixed',
        backgroundColor: 'rgba(0,0,0,0.7)',
        zIndex: 10010,
        top: 0,
        left: 0,
        bottom: 0,
        right: 0,
    },
    modalInner: {
        position: 'absolute',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        width: 640,
        backgroundColor: colors.white,
        borderRadius: 20,
        padding: 30,
        overflow: 'auto',
        maxHeight: '96%',

        [mediaCSS.tabMini]: {
            width: '96%',
            padding: 10,
        },
    },
    table: {
        width: '100%',
        border: `1px solid ${colors.grey}`,
    },
    trSelection: {
        borderTop: `1px solid ${colors.grey}`,

        td: {
            verticalAlign: 'middle',
            padding: 10,
            boxSizing: 'border-box',
        },
        'td:first-child': {
            width: 20,
        },
    },
    trHeader: {
        backgroundColor: colors.greyLight,
    },
    modalTitle: {
        fontSize: 22,
        marginBottom: 30,
    },
    modalDesc: {
        fontSize: 16,
        marginBottom: 12,
    },
    buttons: {
        ...grid.row,
        ...grid.center,
        marginTop: 30,
    },
    modalButton: {
        display: 'flex',
        justifyContent: 'center',
        width: 150,
        margin: '0 10px',
    },
}

addStyles(styles)
export default styles
